import { ResolveFn } from '@angular/router';
import {Workstats} from "@models/Workstats.model";
import {APIService} from "@shared/api.service";
import {inject} from "@angular/core";
import {tap} from "rxjs";

export const homeResolver: ResolveFn<Workstats> = (route, state) => {
  const apiService = inject(APIService);
  return apiService.get('workstats.json').pipe(tap((workstats: Workstats) => {
    apiService.workstats$.next(workstats)
  }));
};
